import React from 'react';
import AuthDialogContextProvider from '../../src/front/components/AuthDialog/AuthDialogContextProvider';

export const Ana = require('../../src/feature/Ana/Ana').default;
export const Jtb = require('../../src/feature/Jtb/Jtb').default;
export const Hida = require('../../src/feature/hida').Hida;
export const Saga = require('../../src/feature/saga');
export const Toyono = require('../../src/feature/toyono');
export const LocalDelivery = require('../../src/feature/LocalDelivery');
export const Ambassador = require('../../src/feature/Ambassador');

export const PlanCard = require('../../src/front/Plans/Card').default;
export const PlanCardWithAuthProvider = (props) => (
  <AuthDialogContextProvider>
    <PlanCard {...props} />
  </AuthDialogContextProvider>
);
